import * as React from 'react'
import Section from '../Section'
import * as Styled from './VariableContent.styles'

const VariableContent = ({
  alignImageToBottom = false,
  alignMainContent = 'Center',
  backgroundColor = null,
  backgroundImage = null,
  bottomPadding = null,
  centeredContent = false,
  children = null,
  image = null,
  mainContent = null,
  mobileAlignImageToBottom = false,
  mobileBackgroundImage = null,
  mobileImage = null,
  mobileTextColor = null,
  textColor = null,
  topPadding = null,
  width = null,
  ...props
}) => (
  <Section
    className={`leshen-variable-content background-color-${
      backgroundColor || 'default'
    } leshen-variable-content-${centeredContent ? 'centered' : 'left'}`}
    backgroundColor={backgroundColor}
    textColor={textColor}
    mobileTextColor={mobileTextColor}
    alignMainContent={alignMainContent}
    topPadding={topPadding}
    bottomPadding={bottomPadding}
    width={width}
    {...props}
  >
    {backgroundImage && (
      <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
        {backgroundImage}
      </Styled.BackgroundImage>
    )}
    {mobileBackgroundImage && (
      <Styled.MobileBackgroundImage>
        {mobileBackgroundImage}
      </Styled.MobileBackgroundImage>
    )}
    {mainContent && (
      <Styled.Content
        hasChildren={Boolean(children)}
        alignMainContent={alignMainContent?.toLowerCase()}
        centeredContent={centeredContent}
        className="content variable-content"
        useMobileImage={Boolean(mobileImage)}
        hasBackgroundImage={Boolean(backgroundImage)}
      >
        {/* If mobile image is set, use mobileImage, otherwise use image */}
        {!alignImageToBottom && image && (
          <Styled.DesktopImage alignImageToBottom={alignImageToBottom}>
            {image}
          </Styled.DesktopImage>
        )}
        {!mobileAlignImageToBottom && mobileImage && (
          <Styled.MobileImage
            mobileAlignImageToBottom={mobileAlignImageToBottom}
          >
            {mobileImage}
          </Styled.MobileImage>
        )}
        {mainContent}
        {alignImageToBottom && image && (
          <Styled.DesktopImage alignImageToBottom={alignImageToBottom}>
            {image}
          </Styled.DesktopImage>
        )}
        {mobileAlignImageToBottom && mobileImage && (
          <Styled.MobileImage
            mobileAlignImageToBottom={mobileAlignImageToBottom}
          >
            {mobileImage}
          </Styled.MobileImage>
        )}
      </Styled.Content>
    )}
    {children}
  </Section>
)

export default VariableContent
